<template>
    <div class="row">
        <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
            <div class="service-grid">
                <div class="ht-service-box--two text-center style-03">
                    <router-link to="">
                        <div class="image mb-20">
                            <img :src="item.icon" class="img-fluid" alt="aeroland-startup-box-icon-01">
                        </div>
                        <div class="content">
                            <h6 class="heading">{{ $t(item.heading) }}</h6>
                            <div class="service_text">{{ $t(item.text) }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartUpFeatureTwo',
        data (){
            return {
                items: [
                    {
                       icon: require('../assets/img/icons/aeroland-startup-box-icon-01.png'), 
                       heading: 'gelistirme', 
                       text: 'Her yeni gün gelişen koşullara uygun ve istekleriniz doğrultusunda projeler geliştiriyoruz'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-02.png'), 
                        heading: 'sosyalmedya', 
                        text: 'Yaptıklarımızı ve Yapacaklarımızı Sosyal medya aracılığı ile siz değerli müşterilere ulaştırmaya çalışıyoruz'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-03.png'), 
                        heading: 'satispazarlama', 
                        text: 'Mevcut bayii alt yapısını korumaya ve yenilerini geliştirmeye özen gösteriyoruz'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-04.png'), 
                        heading: 'guvenlik', 
                        text: 'Her geçen gün veri güvenliği ve kişisel bilgilerin önemini bilerek güvenlik alt yapısını geliştiriyoruz.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-05.png'), 
                        heading: 'bildirim', 
                        text: 'Her yeni günde yapılan değişiliklerle yenilikleri siz değerli müşteri ve bayiilerimize bildiriyoruz.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-startup-box-icon-06.png'), 
                        heading: 'optimizasyon', 
                        text: 'Her yeniliğin Bilgisayarınızda, Webte, Cepte, Tablette çalışmasını sağlamaya çalışıyoruz.'
                    },
                ]
            }
        }
    }
</script>
